import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const isServerUrl = req.url.startsWith(environment.serverUrl) || !/^(http|https):/i.test(req.url);
  return next(isServerUrl ? req.clone({ withCredentials: true }) : req);
};
